import { VisitTour } from "./visit";

export function Tours() {
  return (
    <>
      <VisitTour />
    </>
  );
}
